<template>
  <div>
    <wc-page-title :title='title' :loading='isLoading'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' sm='6' md='4'>
          <wc-data-box :title='"Scheduled Work - " + user.first_name' :loading='isLoading'>
            <v-card-text v-if='yourRoutes.length > 1' class='error--text'>
              You are assigned to multiple routes.
            </v-card-text>
            <v-divider v-if='yourRoutes.length > 1'></v-divider>
            <v-card-text v-if='yourRoutes.length === 0'>
              {{ isLoading ? "loading..." : "You have no work orders assigned to you today."}}
            </v-card-text>
            <template v-else v-for='(route, index) in yourRoutes'> 
              <route-details
                :key='route.id'
                :routeID='route.id'
              ></route-details>
              <v-divider :key='index' v-if='index < yourRoutes.length - 1'></v-divider>
            </template>
          </wc-data-box>
        </v-col>
        <v-col cols='12' sm='6' md='4' v-if='routes'>
          <todays-routes
            v-for='(schedule, index) in schedules'
            :key='schedule.id'
            :class='index !== 0 ? "mb-6" : "none"'
            :schedule='schedule'
            :division='getDivisionForSchedule(schedule.division)'
            :routes='getRoutesForSchedule(schedule.id)'
          ></todays-routes>
        </v-col>
        <v-col cols='12' sm='6' md='4'>
            <wc-data-box
            title="Regular Snow Schedule"
            titleIcon='mdi-snowflake'
            titleIconColor='info'
          >
            <v-list v-if="snowProjectGroups.length">
              <v-list-item v-for='g in snowProjectGroups' :key='g.id' @click='openProjectGroup(g)'>
                <v-list-item-content>
                  <v-list-item-title v-if='g.description'>
                    {{ g.description }}
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    Group {{ g.route_group }} (no description)
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </wc-data-box>

          <wc-data-box
            class='mt-6'
            title="Regular Mowing Schedule"
            titleIcon='mdi-grass'
            titleIconColor='green'
          >
            <v-list v-if="lawnProjectGroups.length">
              <v-list-item v-for='g in lawnProjectGroups' :key='g.id' @click='openProjectGroup(g)'>
                <v-list-item-content>
                  <v-list-item-title v-if='g.description'>
                    {{ g.description }}
                    <!-- add weekly status icon? -->
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    Group {{ g.route_group }} (no description)
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import scheduleAPI from '@/modules/schedule/api/schedule';
import projectsAPI from '@/modules/projects/api/projects';
import RouteDetails from './RouteDetails';
import TodaysRoutes from './TodaysRoutes';

export default {
  name: 'dashboard',
  data: () => ({
    isLoading: true,
    schedules: [],
    routes: [],
    lawnProjectGroups: [],
    snowProjectGroups: [],
  }),
  computed: {
    user () {
      return this.$store.state.auth.profile
    },
    title () {
      return moment().format('dddd MMMM D, YYYY')
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    yourRoutes () {
      return this.routes.filter(r => r.lead === this.user.id || r.copilot === this.user.id || r.other_copilots.find(other_copilot => other_copilot.pilot === this.user.id));
    },
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    },
    lawnDivision () {
      return _.find(this.divisions, d => d.division === 'Lawn')
    },
    snowDivision () {
      return _.find(this.divisions, d => d.division === 'Snow')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      let tmp = await scheduleAPI.getSchedules();
      this.schedules = _.filter(tmp, s => s.is_archived === false)
      let lawnGroups = await projectsAPI.getProjectRouteGroups(this.lawnDivision.id)
      this.lawnProjectGroups = _.orderBy(lawnGroups, 'route_group')
      let snowGroups = await projectsAPI.getProjectRouteGroups(this.snowDivision.id)
      this.snowProjectGroups = _.orderBy(snowGroups, 'route_group')
      for (let i = 0; i < this.schedules.length; i++) {
        let tmp = await scheduleAPI.getRoutesForDateRange(this.today, this.today, this.schedules[i].id)
        if (tmp.length) {
          this.routes = this.routes.concat(tmp)
        }
      }
      this.isLoading = false
    },
    getRoutesForSchedule(scheduleID) {
      return _.filter(this.routes, r => r.schedule === scheduleID)
    },
    getDivisionForSchedule(divID) {
        const division = _.find(this.divisions, d => d.id === divID)
        if(!division || division.division_type === "S" || division.division_type === "L" || division.division_type === "C"){
            return null;
        }
      return division;
    },
    openProjectGroup(g) {
      this.$router.push({ name: 'ProjectRoute', params: { id: g.id } })
    }
  },
  components: {
    'route-details': RouteDetails,
    'todays-routes': TodaysRoutes
  }
}
</script>
